import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'gatsby';
import BlogCard from '../blog/BlogCard';
import * as styles from './homeSectionBlogs.module.scss';

const HomeSectionBlogs = ({ blogs }) => (
  <section className={styles.section}>
    <Container>
      <h2 className={styles.title}>
        <span className={styles.titleLine} />
        <span className={styles.titleText}>Blog</span>
        <Link className={styles.titleLink} to="/blog">View more articles</Link>
      </h2>

      <Row>
        {blogs.map(({ blog }) => (
          <Col
            key={blog.uid}
            className={styles.blog}
            xs={12}
            md={6}
            lg={4}
          >
            <BlogCard
              url={`/blog/${blog.uid}`}
              title={blog.document.data.title.text}
              titleEl="h3"
              image={blog.document.data.featured_block_image}
              more="Read more"
            />
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);

export default HomeSectionBlogs;
